(function(){
  if(window.__jmMiniMeInit) return;
  window.__jmMiniMeInit = true;

  function paintCount(n){
    document.querySelectorAll('.jm-cartcount').forEach(function(e){
      e.setAttribute('data-count', n);
      e.textContent = n > 99 ? '99+' : n;
    });
  }

  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ paintCount(c.item_count || 0); })
      .catch(function(){});
  }
  refreshCart();

  // The theme (Allure) drives its cart drawer through themeCore.EventBus
  function hasDrawer(){
    return !!(window.themeCore && themeCore.EventBus && document.getElementById('CartDrawer'));
  }

  function openDrawer(){
    if(hasDrawer()){ themeCore.EventBus.emit('cart:drawer:refresh-and-open'); return; }
    window.location.href = '/cart';
  }

  document.querySelectorAll('.jm-cartbtn').forEach(function(b){
    b.addEventListener('click', openDrawer);
  });

  if(window.themeCore && themeCore.EventBus){
    themeCore.EventBus.listen('cart:updated', refreshCart);
  }

  var drawerEl = document.getElementById('CartDrawer');
  if(drawerEl && window.MutationObserver){
    var deb;
    new MutationObserver(function(){
      clearTimeout(deb);
      deb = setTimeout(refreshCart, 500);
    }).observe(drawerEl, {attributes:true, attributeFilter:['class'], childList:true, subtree:true});
  }

  var forms = Array.prototype.slice.call(document.querySelectorAll('.jm-kform'));
  var hero = document.getElementById('jm-buy');

  function swatchByName(name){
    var all = document.querySelectorAll('.jm-sw');
    for(var i=0; i<all.length; i++){ if(all[i].getAttribute('data-name') === name) return all[i]; }
    return null;
  }

  function showImage(src){
    if(!src) return;
    var big = document.querySelector('.jm-mainimg');
    if(big && src.getAttribute('data-img')){ big.removeAttribute('srcset'); big.src = src.getAttribute('data-img'); }
    var st = document.querySelector('.jm-stimg');
    if(st && src.getAttribute('data-thumb')){ st.src = src.getAttribute('data-thumb'); }
  }

  function select(id, scroll){
    var src = document.querySelector('.jm-sw[data-vid="'+id+'"]');
    if(!src || src.disabled) return;
    document.querySelectorAll('.jm-sw').forEach(function(b){
      b.classList.toggle('on', b.getAttribute('data-vid') === String(id));
    });
    document.querySelectorAll('.jm-vname').forEach(function(e){ e.textContent = src.getAttribute('data-name'); });
    showImage(src);
    // Kaching listens to the form's id input and syncs its own pickers to it
    forms.forEach(function(f){
      var inp = f.querySelector('input[name="id"]');
      if(!inp) return;
      inp.value = id;
      inp.dispatchEvent(new Event('change', {bubbles:true}));
    });
    if(scroll && hero) hero.scrollIntoView({behavior:'smooth', block:'center'});
  }

  document.querySelectorAll('.jm-sw').forEach(function(b){
    b.addEventListener('click', function(){ select(b.getAttribute('data-vid'), false); });
  });

  document.querySelectorAll('.jm-pick').forEach(function(c){
    c.addEventListener('click', function(){ select(c.getAttribute('data-vid'), true); });
    c.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(c.getAttribute('data-vid'), true); } });
  });

  // ?deal=N (1 = first Kaching tier) preselects a tier, e.g. links from the listicle prelander
  var wantDeal = parseInt(new URLSearchParams(window.location.search).get('deal'), 10);
  function applyDealParam(f){
    if(!wantDeal || f.__jmDealApplied) return;
    var radios = f.querySelectorAll('.kaching-bundles__bar input[type="radio"]');
    if(!radios.length) return;
    f.__jmDealApplied = true;
    var r = radios[wantDeal - 1];
    if(r && !r.checked) r.click();
  }

  // Mirror the selected Kaching deal into the button, the sticky bar and the picker mode
  function syncDeal(f){
    applyDealParam(f);
    var bar = f.querySelector('.kaching-bundles__bar--selected');
    if(!bar) return;
    var price = bar.querySelector('.kaching-bundles__bar-price');
    var title = bar.querySelector('.kaching-bundles__bar-title');
    var p = price ? price.textContent.trim() : '';
    if(p) f.querySelectorAll('.jm-vprice').forEach(function(e){ e.textContent = p; });
    // Multi-unit deals carry one Kaching picker per phone, so the swatch row steps aside
    f.classList.toggle('is-multi', bar.querySelectorAll('.kaching-bundles__bar-variant-select').length > 1);
    f.classList.add('is-ready');
    if(f === hero){
      document.querySelectorAll('.jm-sprice').forEach(function(e){ if(p) e.textContent = p; });
      document.querySelectorAll('.jm-sdeal').forEach(function(e){ if(title) e.textContent = title.textContent.trim(); });
    }
  }

  forms.forEach(function(f){
    var kb = f.querySelector('kaching-bundle');
    if(kb && window.MutationObserver){
      var t;
      new MutationObserver(function(){
        clearTimeout(t);
        t = setTimeout(function(){ syncDeal(f); }, 40);
      }).observe(kb, {childList:true, subtree:true, attributes:true, attributeFilter:['class'], characterData:true});
    }
    f.addEventListener('change', function(e){
      var el = e.target;
      if(f === hero && el && el.classList && el.classList.contains('kaching-bundles__bar-variant-select')){
        showImage(swatchByName(el.value));
      }
      setTimeout(function(){ syncDeal(f); }, 60);
    });
    // Add without leaving the page. Kaching patches fetch and rewrites this request into
    // the selected deal's line items (mixed characters, deal properties), then the drawer opens.
    f.addEventListener('submit', function(e){
      if(!hasDrawer() || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var b = f.querySelector('.jm-atc');
      if(b){ if(b.classList.contains('busy')) return; b.classList.add('busy'); }
      var err = f.querySelector('.jm-err');
      if(err) err.textContent = '';
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: new FormData(f)
      })
      .then(function(r){
        return r.json().then(function(d){
          if(!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
          return d;
        });
      })
      .then(function(){
        if(b) b.classList.remove('busy');
        refreshCart();
        openDrawer();
      })
      .catch(function(ex){
        if(b) b.classList.remove('busy');
        if(!err){
          err = document.createElement('p');
          err.className = 'jm-err';
          (b || f).insertAdjacentElement('afterend', err);
        }
        err.textContent = ex.message;
      });
    });
  });

  document.querySelectorAll('.jm-stbuy').forEach(function(b){
    b.addEventListener('click', function(){
      if(!hero) return;
      var sub = hero.querySelector('button[type="submit"]');
      if(hero.requestSubmit){ hero.requestSubmit(sub); } else if(sub){ sub.click(); }
    });
  });

  var s = document.querySelector('.jm-sticky');
  var anchor = document.getElementById('jm-buy');
  if(s && anchor){
    window.addEventListener('scroll', function(){
      var r = anchor.getBoundingClientRect();
      s.style.visibility = (r.bottom < 0) ? 'visible' : 'hidden';
    }, {passive:true});
  }
})();
